import ClipLoader from "react-spinners/PulseLoader";
import classes from "./AppLoader.module.css";

function AppLoader(props) {
	return (
		<section className={classes.main}>
			<ClipLoader
				color={props.color}
				loading={props.loading}
				size={props.size}
				aria-label="Loading Spinner"
				data-testid="loader"
			/>
		</section>
	);
}
export default AppLoader;
